<template>
  <v-container grid-list-lg>
    <v-layout wrap>
      <v-flex xs6 class="pa-3">
        <v-card>
          <v-card-title class="headline font-weight-regular oem-color">Configuration Record</v-card-title>
          <v-card-text>
            <v-layout row>
              <v-flex>
                <v-list>
                  <v-list-tile>
                    <v-list-tile-content>Generate Configuration Record</v-list-tile-content>
                  </v-list-tile>
                </v-list>
                <div class="ma-3" style="position:relative; top:-20px; left:10px;">
                  <v-checkbox
                    v-model="includeInfo"
                    label="Include General settings"
                    class="oem-text-color"
                  ></v-checkbox>
                  <v-checkbox
                    v-model="includeInstallationRecord"
                    label="Include Installation record"
                    class="oem-text-color"
                  ></v-checkbox>
                  <v-checkbox
                    v-model="includeInputs"
                    label="Include Voltage inputs"
                    class="oem-text-color"
                  ></v-checkbox>
                  <v-checkbox
                    v-model="includeLoad"
                    label="Include Load setup"
                    class="oem-text-color"
                  ></v-checkbox>
                  <v-checkbox v-model="includeCt" label="Include CT input" class="oem-text-color"></v-checkbox>
                  <v-checkbox
                    v-model="includeCommunication"
                    label="Include Communications"
                    class="oem-text-color"
                  ></v-checkbox>
                  <v-checkbox
                    v-model="includePulse"
                    label="Include Pulse IO setup"
                    class="oem-text-color"
                  ></v-checkbox>
                  <v-checkbox
                    v-model="includeAlarms"
                    label="Include Alarm setup"
                    class="oem-text-color"
                  ></v-checkbox>
                  <v-checkbox
                    v-model="includeValidation"
                    label="Include Measurement Validation"
                    class="oem-text-color"
                  ></v-checkbox>
                  <img id="setraLabel" ref="setraLabel" src='../assets/img/SetraBlue_logo.jpg' style="display:none" />
                  <img id="flukeLabel" ref="flukeLabel" src='../assets/img/Fluke_logo.jpg' style="display:none" />
                  <img id="siemensLabel" ref="siemensLabel" src='../assets/img/Siemens_logo.jpg' style="display:none" />
                </div>
              </v-flex>
              <v-flex xs4>
                <v-list>
                  <v-list-tile>
                    <v-list-tile-content>
                      <v-btn
                        class="oem-button"
                        @click="exportPdf()"
                        style="margin-left: auto;"
                      >Export</v-btn>
                    </v-list-tile-content>
                  </v-list-tile>
                </v-list>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs6 class="pa-3">
        <v-card>
          <v-card-title class="headline font-weight-regular oem-color">Clone / Import Meter Setup</v-card-title>
          <v-card-text>
            <v-layout row>
              <v-flex>
                <v-list>
                  <v-list-tile>
                    <v-list-tile-content>Clone Meter Setup</v-list-tile-content>
                  </v-list-tile>
                  <v-list-tile>
                    <v-list-tile-content>Import Meter Setup</v-list-tile-content>
                  </v-list-tile>
                </v-list>
                <div class="ma-3" style="position:relative; top:-20px; left:10px;">
                  <v-checkbox
                    v-model="exportInfo"
                    label="Import General settings"
                    class="oem-text-color"
                  ></v-checkbox>
                  <v-checkbox
                    v-model="exportInputs"
                    label="Import Voltage inputs"
                    class="oem-text-color"
                  ></v-checkbox>
                  <v-checkbox v-model="exportLoad" label="Import Load setup" class="oem-text-color"></v-checkbox>
                  <v-checkbox v-model="exportCt" label="Import CT input" class="oem-text-color"></v-checkbox>
                  <v-checkbox
                    v-model="exportCommunication"
                    label="Import Communications"
                    class="oem-text-color"
                  ></v-checkbox>
                  <v-checkbox
                    v-model="exportPulse"
                    label="Import Pulse IO setup"
                    class="oem-text-color"
                  ></v-checkbox>
                  <v-checkbox
                    v-model="exportAlarms"
                    label="Import Alarm setup"
                    class="oem-text-color"
                  ></v-checkbox>
                </div>
              </v-flex>
              <v-flex xs4 class="float-right">
                <v-list class="float-right">
                  <v-list-tile class="float-right">
                    <v-list-tile-content class="float-right">
                      <v-btn
                        class="oem-button"
                        @click="exportConfig()"
                        style="margin-left: auto;"
                      >Export</v-btn>
                    </v-list-tile-content>
                  </v-list-tile>
                  <v-list-tile>
                    <v-list-tile-content>
                      <v-btn
                        class="oem-button"
                        @click="importConfig()"
                        style="margin-left: auto;"
                      >Import</v-btn>
                    </v-list-tile-content>
                  </v-list-tile>
                </v-list>
              </v-flex>
            </v-layout>
            <a href="powermeter-config.json" download="powermeter-config.json" ref="downloadLink"></a>
            <input
              v-bind:style="{ display: 'none' }"
              type="file"
              accept=".json"
              ref="fileInput"
              @change="handleImport"
            />
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs6 class="pa-3">
        <v-card>
          <v-card-title class="headline font-weight-regular oem-color">Alarm Logs</v-card-title>
          <v-card-text>
            <v-layout row>
              <v-flex>
                <v-list>
                  <v-list-tile>
                    <v-list-tile-content>Generate Alarm Logs Record</v-list-tile-content>
                  </v-list-tile>
                </v-list>
              </v-flex>
              <v-flex xs4 class="float-right">
                <v-list class="float-right">
                  <v-list-tile class="float-right">
                    <v-list-tile-content class="float-right">
                      <v-btn
                        class="oem-button"
                        @click="exportAlarmLogs()"
                        style="margin-left: auto;"
                      >Export</v-btn>
                    </v-list-tile-content>
                  </v-list-tile>
                </v-list>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-dialog v-model='generatedByDialog' ref='generatedByDialog' persistent max-width='500px'>
        <v-card>
          <v-card-title class='headline font-weight-regular oem-color'>
            Add User Details
          </v-card-title>
          <v-card-text>
            <v-flex xs12>
              <v-text-field
                ref="GeneratedBy"
                v-model="GeneratedBy"
                data-vv-name="Generated by"
                hint='Max 30 characters'
                :error-messages="errors.collect('Generated by')"
                :label='"Generated by:"'
                :rules="[
                  () => !!GeneratedBy || 'This field is required',
                  () => !!GeneratedBy && GeneratedBy.length <= 30 || 'GeneratedBy must be less than 30 characters'
                ]"
                counter
                maxlength='30'
                require
              ></v-text-field>
            </v-flex>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn class='oem-button' flat @click='cancel()'>
              Cancel
            </v-btn>
            <v-btn class='oem-button' flat @click='confirm()'>OK</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model='updateDialog' persistent max-width='500px'>
        <v-card class="mx-auto">
          <v-card-title class='headline font-weight-regular oem-color'>
            File Download
          </v-card-title>
          <v-card-text>
            <span class='oem-text-color'>
              <div class="d-flex ma-3">
                {{ updateText }}
                <v-spacer></v-spacer>
                <hollow-dots-spinner
                  :animation-duration="1000"
                  :dot-size="15"
                  :dots-num="3"
                  color= "var(--primary-color)"
                  class="pl-5"
                ></hollow-dots-spinner>
              </div>
            </span>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-snackbar v-model="snackbar" :timeout="5000" :top="true">
        {{ snackbarText }}
        <v-btn class="oem-color-text" flat @click="snackbar = false">Close</v-btn>
      </v-snackbar>
    </v-layout>
  </v-container>
</template>

<script>
import Vue from 'vue';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import { HollowDotsSpinner } from 'epic-spinners';
import ajax from '../ajax';

pdfMake.vfs = pdfFonts.pdfMake.vfs;

export default {
  name: 'Export',
  components: {
    HollowDotsSpinner,
  },
  data() {
    return {
      storeState: this.$store.state,
      includeInfo: true,
      includeInstallationRecord: true,
      includeInputs: true,
      includeLoad: true,
      includeCt: true,
      includeAlarms: true,
      includeCommunication: true,
      includePulse: true,
      includeValidation: true,
      exportInfo: true,
      exportInputs: true,
      exportLoad: true,
      exportCt: true,
      exportAlarms: true,
      exportCommunication: true,
      exportPulse: true,
      snackbar: false,
      snackbarText: '',
      powerFactorOptions: [{ text: 'IEC', value: 0 }, { text: 'IEEE', value: 1 }],
      updateDialog: false,
      generatedByDialog: false,
      updateText: '',
      GeneratedBy: '',
      exportSource: '',

      // For the Pdf:
      doc: {},
      actualVoltage: ['No voltage present', 'No voltage present'],
    };
  },
  methods: {
    hashCode(str) {
      if (str === '' || str === undefined) {
        return 0;
      }
      return str.split('').reduce(
        (prevHash, currVal) =>
          // eslint-disable-next-line
          ((prevHash << 5) - prevHash + currVal.charCodeAt(0)) | 0,
        0,
      );
    },

    exportPdf() {
      if (this.GeneratedBy === '') {
        this.exportSource = 'CONFIG';
        this.getUserName();
        return;
      }
      // gather all required data
      const copy = JSON.parse(JSON.stringify(this.storeState.data));

      if (this.includeInputs) {
        this.getVoltage(copy, () => {
          this.generatePdf(copy);
        });
      } else {
        this.generatePdf(copy);
      }
    },
    getServicePhases(service) {
      // eslint-disable-next-line
      let phases = 0;
      if (service === 1
          || service === 2
          || service === 3) {
        phases = 3;
      } else if (service === 4) {
        phases = 2;
      } else if (service === 5) {
        phases = 1;
      }
      return phases;
    },
    getUserName() {
      this.GeneratedBy = '';
      this.generatedByDialog = true;
    },
    generatePdf(data) {
      this.updateText = 'Downloading the file. Please wait.';
      this.updateDialog = true;
      const fileName = `SPM${this.$store.getDeviceModelNumberText()}EDN_${this.storeState.data.deviceInfo.serial}_Install_Record.pdf`;
      // document basics
      this.doc = {
        info: {
          title: fileName,
        },
        styles: {
          header: {
            fontSize: 18,
            bold: true,
            color: '#1d428a',
          },
          subheader: {
            fontSize: 15,
            bold: true,
            color: '#1d428a',
            // alignment: 'center'
          },
          setraTable: {},
          tableHeader: {
            bold: true,
            fontsize: 13,
          },
        },
        content: [
          {
            image: 'data:image/jpeg;base64,' + this.OEMlabel(),
            width: this.getOEMLabelWidth(),
            height: this.getOEMLabelHeight(),
            alignment: 'right',
          },
          { text: 'Powermeter Installation Record\n', style: 'header' },
        ],
      };
      // Adding date and time here
      const dateNTime = `${this.getCurrentTime().toLocaleDateString('en-US')}, ${this.getCurrentTime().toLocaleTimeString('en-US')}`;
      const generatedDateTime = [
        {
          style: 'setraTable',
          layout: 'noBorders',
          table: {
            widths: [80, '*'],
            body: [
              ['Generated on: ', dateNTime],
            ],
          },
        },
      ];
      this.doc.content.push(generatedDateTime);

      // Adding user name generated by here
      const generatedUser = [
        {
          style: 'setraTable',
          layout: 'noBorders',
          table: {
            widths: [80, '*'],
            body: [
              ['Generated by: ', this.GeneratedBy],
            ],
          },
        },
      ];
      this.doc.content.push(generatedUser);

      // add content when requested
      if (this.includeInfo) {
        const generalInfo = [
          { text: '\nGeneral Information', style: 'subheader' },
          {
            style: 'setraTable',
            layout: 'noBorders',
            table: {
              widths: [200, '*'],
              body: [
                ['Installation Site', data.general.siteInfo.site],
                ['Address 1', data.general.siteInfo.addr1],
                ['Address 2', data.general.siteInfo.addr2],
                ['Electrical Contractor', data.report.general.contractor],
                ['Electrician', data.report.general.electrician],
                ['Electrician Phone #', data.report.general.phone],
                ['Panel Number', data.general.siteInfo.panel],
                ['Panel Type', data.general.siteInfo.type],
                ['Panel Maximum Fault Current', data.report.general.faultCurrent],
                ['Panel Location 1', data.general.siteInfo.loc1],
                ['Panel Location 2', data.general.siteInfo.loc2],
              ],
            },
          },
        ];
        this.doc.content.push(generalInfo);
      }
      if (this.includeInstallationRecord) {
        const installRec = [
          { text: '\nMeter Information', style: 'subheader' },
          {
            style: 'setraTable',
            layout: 'noBorders',
            table: {
              widths: [200, '*'],
              body: [
                ['Manufacturer', 'Setra Systems, Inc.'],
                ['Product', `SPM${this.$store.getDeviceModelNumberText()}EDN`],
                ['Serial Number', data.deviceInfo.serial],
                ['Meter Install Location', data.report.meter.location],
                ['Power Factor Sign Convention', this.powerFactorOptions[this.storeState.data.general.defaults.powerFactorSign].text],
                ['Demand Window', this.storeState.data.general.defaults.demandWindow],
              ],
            },
          },
          { text: '\nGeneral Notes', style: 'subheader' },
          { text: data.report.generalNotes.notes },
        ];
        this.doc.content.push(installRec);
      }
      if (this.includeInputs) {
        const inputList = [{ text: '\nInput Voltage', style: 'subheader' },
        ];
        // loop over inputs
        for (let i = 0; i < data.inputs.length; i++) {
          if (data.inputs[i].active) {
            const inputItem = [
              { text: `Vin${i + 1}`, bold: true },
              {
                style: 'setraTable',
                layout: 'noBorders',
                table: {
                  widths: [200, '*'],
                  body: [
                    ['Service Type', this.storeState.serviceOptions.find(({ value }) => value === data.inputs[i].service).text],
                    ['Expected Voltage (VAC)', data.inputs[i].voltage],
                    ['Actual Voltage (VAC)', this.actualVoltage[i]],
                    ['Potential Transformer Multiplier', data.inputs[i].voltageScaler],
                    ['Service Wire Correction\n\n', this.checkServiceWiring(data.inputs[i])],
                  ],
                },
              },
            ];
            inputList.push(inputItem);
            if (this.checkServiceWiring(data.inputs[i]) === 'Yes') {
              const serviceWireItem = [
                {
                  style: 'setraTable',
                  layout: 'noBorders',
                  table: {
                    widths: [30, 170, 30, '*'],
                    body: [],
                  },
                },
              ];
              const serviceType = data.inputs[i].service;
              const ServiceWirConnectors = [];
              if (this.getServicePhases(serviceType) === 1) {
                ServiceWirConnectors.push(
                  ['', 'L1 Connector\n\n', '', `L${(i === 0) ? (data.inputs[i].lines[0].channel + 1) : (data.inputs[i].lines[0].channel - 2)}`],
                );
              } else if (this.getServicePhases(serviceType) === 2) {
                ServiceWirConnectors.push(
                  ['', 'L1 Connector', '', `L${(i === 0) ? (data.inputs[i].lines[0].channel + 1) : (data.inputs[i].lines[0].channel - 2)}`],
                  ['', 'L2 Connector\n\n', '', `L${(i === 0) ? (data.inputs[i].lines[1].channel + 1) : (data.inputs[i].lines[1].channel - 2)}`],
                );
              } else if (this.getServicePhases(serviceType) === 3) {
                ServiceWirConnectors.push(
                  ['', 'L1 Connector', '', `L${(i === 0) ? (data.inputs[i].lines[0].channel + 1) : (data.inputs[i].lines[0].channel - 2)}`],
                  ['', 'L2 Connector', '', `L${(i === 0) ? (data.inputs[i].lines[1].channel + 1) : (data.inputs[i].lines[1].channel - 2)}`],
                  ['', 'L3 Connector\n\n', '', `L${(i === 0) ? (data.inputs[i].lines[2].channel + 1) : (data.inputs[i].lines[2].channel - 2)}`],
                );
              }

              for (let idx = 0; idx < ServiceWirConnectors.length; idx++) {
                serviceWireItem.find(({ style }) => style === 'setraTable').table.body.push(ServiceWirConnectors[idx]);
              }
              inputList.push(serviceWireItem);
            }
          }
        }
        this.doc.content.push(inputList);
      }
      if (this.includeLoad) {
        const loadList = [
          { text: '\nLoad Configuration', style: 'subheader' },
          {
            style: 'setraTable',
            table: {
              widths: ['auto', 200, '*', '*', '*', '*', '*'],
              headerRows: 1,
              body: [
                [{ text: 'Load #', style: 'tableHeader' }, { text: 'Load Name', style: 'tableHeader' }, { text: 'VDI', style: 'tableHeader' }, { text: 'Vin', style: 'tableHeader' }, { text: 'L1', style: 'tableHeader' }, { text: 'L2', style: 'tableHeader' }, { text: 'L3', style: 'tableHeader' }],
              ],
            },
          },
        ];
        // loop over all loads
        for (let i = 0; i < data.loads.length; i++) {
          const loadItem = [
            data.loads[i].id + 1,
            data.loads[i].name,
            (((data.loads[i].vdi === undefined) || (data.loads[i].vdi === '')) ? 'N/A' : data.loads[i].vdi),
            `Vin${data.loads[i].input + 1}`,
            ((data.loads[i].cts[0].channel === 0) ? '-' : `CT${(data.loads[i].cts[0].channel - 5)}`),
            ((data.loads[i].cts[1].channel === 0) ? '-' : `CT${(data.loads[i].cts[1].channel - 5)}`),
            ((data.loads[i].cts[2].channel === 0) ? '-' : `CT${(data.loads[i].cts[2].channel - 5)}`),
          ];
          // add item to table
          loadList.find(({ style }) => style === 'setraTable').table.body.push(loadItem);
        }
        this.doc.content.push(loadList);
      }
      if (this.includeCt) {
        const ctList = [
          { text: '\nCT Inputs', style: 'subheader' },
          {
            style: 'setraTable',
            table: {
              widths: ['auto', '*', '*', '*', '*'],
              headerRows: 1,
              body: [
                [{ text: 'CT #', style: 'tableHeader', noWrap: true }, { text: 'Type', style: 'tableHeader' }, { text: 'Rated Current (A)', style: 'tableHeader' }, { text: 'CT(mV)\nRogowski(mV/kA)', style: 'tableHeader' }, { text: 'Polarity Correction', style: 'tableHeader' }],
              ],
            },
          },
        ];
        // loop over all CTs
        for (let i = 0; i < data.allCts.length; i++) {
          if (data.allCts[i].active) {
            const ctText = this.storeState.ctTypes.find(({ value }) => value === data.allCts[i].type).text;
            const ctItem = [
              data.allCts[i].channel - 5,
              ctText,
              (ctText === 'User defined' ? data.allCts[i].maxRating : this.storeState.ctTypes[data.allCts[i].type].maxCurrent),
              (ctText === 'User defined' ? data.allCts[i].maxOutput : this.storeState.ctTypes[data.allCts[i].type].maxVoltage),
              (data.allCts[i].inverse) ? 'Yes' : 'No',
            ];
            // add item to table
            ctList.find(({ style }) => style === 'setraTable').table.body.push(ctItem);
          }
        }
        this.doc.content.push(ctList);
      }
      if (this.includeCommunication) {
        const ethList = [
          { text: '\nNetwork Settings', style: 'subheader' },
          {
            style: 'setraTable',
            layout: 'noBorders',
            table: {
              widths: [200, '*'],
              body: [
                ['DHCP or Static', (data.ethernet.dhcp ? 'DHCP' : 'Static')],
                ['MAC Address', data.ethernet.macAddress],
                ['IP Address', data.ethernet.ipAddress],
                ['Gateway Address', data.ethernet.gatewayAddress],
                ['Subnet Mask', data.ethernet.subnetMask],
              ],
            },
          },
        ];
        this.doc.content.push(ethList);

        const commList = [
          { text: '\nCommunications', style: 'subheader' },
          {
            style: 'setraTable',
            layout: 'noBorders',
            table: {
              widths: [200, '*'],
              body: [
                ['Type', this.storeState.communicationTypeOptions.find(({ value }) => value === data.communications.type).text],
              ],
            },
          },
        ];
        const commItem = [];
        if (data.communications.type === 'bac_ip' || data.communications.type === 'bac_mstp') {
          commItem.push(
            ['Device Instance', data.communications.bacnet.baseInstance],
            ['Device Name', data.communications.bacnet.baseName],
            ['Virtual Network Number', data.communications.bacnet.network],
          );
          if (data.communications.type === 'bac_ip') {
            commItem.push(
              ['UDP Port', data.communications.bacnet.port],
              ['BBMD Address', data.communications.bacnet.bbmdAddress],
              ['BBMD TTL', data.communications.bacnet.bbmdTtl],
            );
          } else {
            commItem.push(
              ['Baud Rate', data.communications.bacnet.baudrate],
              ['MAC Address', data.communications.bacnet.macAddress],
              ['Max Master', data.communications.bacnet.maxMaster],
            );
          }
        } else if (data.communications.type === 'mb_tcp') {
          commItem.push(
            ['TCP Port', data.communications.modbus.port],
          );
        } else if (data.communications.type === 'mb_rtu') {
          commItem.push(
            ['Baud Rate', data.communications.modbus.baudrate],
            ['Parity', this.storeState.parityOptions.find(({ value }) => value === data.communications.modbus.parity).text],
            ['Node Address', data.communications.modbus.address],
          );
        }
        for (let i = 0; i < commItem.length; i++) {
          commList.find(({ style }) => style === 'setraTable').table.body.push(commItem[i]);
        }
        this.doc.content.push(commList);
      }
      if (this.includePulse) {
        const pulseList = [
          { text: '\nPulse I/O', style: 'subheader' },
        ];
        // loop over pulse I/O's
        for (let i = 0; i < data.pulse.length; i++) {
          const pulseActive = data.pulse[i].active;
          if (data.pulse[i].out) {
            const pulseItem = [
              { text: 'Pulse Output', bold: true },
              {
                style: 'setraTable',
                layout: 'noBorders',
                table: {
                  widths: [200, '*'],
                  body: [
                    ['Pulse Type', (pulseActive ? this.storeState.pulseOutTypeOptions.find(({ value }) => value === data.pulse[i].type).text : 'Not configured')],
                    ['Units of Measure', (pulseActive ? this.storeState.pulseOutMeasureOptions[data.pulse[i].type].find(({ value }) => value === data.pulse[i].param).text : 'Not configured')],
                    ['Scaler', (pulseActive ? data.pulse[i].scaler : 'Not configured')],
                    ['Pulse Width (ms)', data.pulse[i].pulseWidth],
                  ],
                },
              },
            ];
            pulseList.push(pulseItem);
          } else {
            const pulseItem = [
              { text: `Pulse Input ${i + 1}`, bold: true },
              {
                style: 'setraTable',
                layout: 'noBorders',
                table: {
                  widths: [200, '*'],
                  body: [
                    ['Pulse Type', (pulseActive ? this.storeState.pulseTypeOptions.find(({ value }) => value === data.pulse[i].type).text : 'Not configured')],
                    ['Units of Measure', (pulseActive ? this.storeState.pulseMeasureOptions[data.pulse[i].type].find(({ value }) => value === data.pulse[i].param).text : 'Not configured')],
                    ['Scaler\n\n', (pulseActive ? data.pulse[i].scaler : 'Not configured')],
                  ],
                },
              },
            ];
            pulseList.push(pulseItem);
          }
        }
        this.doc.content.push(pulseList);
      }
      if (this.includeAlarms) {
        const alarmList = [
          { text: '\nAlarm Setup', style: 'subheader' },
          {
            style: 'setraTable',
            table: {
              widths: [20, 110, '*', '*', '*', '*', 30, 30],
              headerRows: 1,
              body: [
                [{ text: '#', style: 'tableHeader' }, { text: 'Type', style: 'tableHeader' }, { text: 'Vin/Line/Load/CT', style: 'tableHeader' }, { text: 'Alarm Set Point', style: 'tableHeader' }, { text: 'Deadband', style: 'tableHeader' }, { text: 'Delay Seconds', style: 'tableHeader' }, { text: 'LED', style: 'tableHeader' }, { text: 'Relay', style: 'tableHeader' }],
              ],
            },
          },
        ];
        // loop over alarms
        for (let i = 0; i < data.alarms.length; i++) {
          const alarmObj = this.storeState.alarmTypes.find(({ value }) => value === data.alarms[i].type);
          const alarmItem = [
            data.alarms[i].id + 1,
            alarmObj.text,
            this.getvinLineLoadOrCtText(data.alarms[i]),
            (alarmObj.setPointApplicable ? `${data.alarms[i].setPoint} ${alarmObj.unit}` : '#NA'),
            (alarmObj.deadbandUnit !== '' ? `${data.alarms[i].deadband} ${alarmObj.deadbandUnit}` : '#NA'),
            (alarmObj.delayApplicable ? data.alarms[i].delay : '#NA'),
            (data.alarms[i].led ? 'Yes' : 'No'),
            (data.alarms[i].relay ? 'Yes' : 'No'),
          ];
          alarmList.find(({ style }) => style === 'setraTable').table.body.push(alarmItem);
        }
        this.doc.content.push(alarmList);
      }
      if (this.includeValidation) {
        const activeInputs = this.activeInputs();
        const activeCts = this.activeCts();
        const validationList = [
          { text: '\nMeasurement Validation', style: 'subheader' },
          {
            style: 'setraTable',
            table: {
              widths: ['*', '*', '*'],
              headerRows: 1,
              body: [
                [{ text: 'Line/CT', style: 'tableHeader' }, { text: 'Multimeter Value', style: 'tableHeader' }, { text: 'Powermeter Value', style: 'tableHeader' }],
              ],
            },
          },
        ];
        // loop over inputs
        activeInputs.forEach((input) => {
          const validationItem = [
            input.text,
            ((data.report.measuredValues[input.id] === undefined
              || data.report.measuredValues[input.id] === '') ? '#NA' : `${data.report.measuredValues[input.id]}`),
            (data.report.meterValues[input.id] === undefined ? '#NA' : `${data.report.meterValues[input.id]} V`),
          ];
          validationList.find(({ style }) => style === 'setraTable').table.body.push(validationItem);
        });
        // loop over cts
        activeCts.forEach((ct) => {
          const validationItem = [
            ct.text,
            ((data.report.measuredValues[ct.id] === undefined
              || data.report.measuredValues[ct.id] === '') ? '#NA' : `${data.report.measuredValues[ct.id]}`),
            (data.report.meterValues[ct.id] === undefined ? '#NA' : `${data.report.meterValues[ct.id]} A`),
          ];
          validationList.find(({ style }) => style === 'setraTable').table.body.push(validationItem);
        });
        this.doc.content.push(validationList);
      }
      this.$timer.start('downloadPowerMeterInstallationRecord');
    },

    downloadPowerMeterInstallationRecord() {
      const fileName = `SPM${this.$store.getDeviceModelNumberText()}EDN_${this.storeState.data.deviceInfo.serial}_Install_Record.pdf`;
      pdfMake.createPdf(this.doc).download(fileName);
      this.updateDialog = false;
      this.updateText = '';
      this.GeneratedBy = '';
      this.$timer.stop('downloadPowerMeterInstallationRecord');
    },

    exportAlarmLogs() {
      if (this.GeneratedBy === '') {
        this.exportSource = 'ALARM_LOG';
        this.getUserName();
        return;
      }
      // document basics
      this.updateText = 'Downloading the file. Please wait.';
      this.updateDialog = true;
      const fileName = `SPM${this.$store.getDeviceModelNumberText()}EDN_${this.storeState.data.deviceInfo.serial}_Alarm_Log.pdf`;
      this.doc2 = {
        info: {
          title: fileName,
        },
        styles: {
          header: {
            fontSize: 18,
            bold: true,
            color: '#1d428a',
          },
          subheader: {
            fontSize: 15,
            bold: true,
            color: '#1d428a',
            // alignment: 'center'
          },
          setraTable: {},
          tableHeader: {
            bold: true,
            fontsize: 13,
          },
        },
        content: [
          {
            image: 'data:image/jpeg;base64,' + this.OEMlabel(),
            width: this.getOEMLabelWidth(),
            height: this.getOEMLabelHeight(),
            alignment: 'right',
          },
          { text: 'Powermeter Alarm Logs Record\n', style: 'header' },
        ],
      };

      // Adding date and time here
      const dateNTime = `${this.getCurrentTime().toLocaleDateString('en-US')}, ${this.getCurrentTime().toLocaleTimeString('en-US')}`;
      const generatedDateTime = [
        {
          style: 'setraTable',
          layout: 'noBorders',
          table: {
            widths: [80, '*'],
            body: [
              ['Generated on: ', dateNTime],
            ],
          },
        },
      ];
      this.doc2.content.push(generatedDateTime);

      // Adding user name generated by here
      const generatedUser = [
        {
          style: 'setraTable',
          layout: 'noBorders',
          table: {
            widths: [80, '*'],
            body: [
              ['Generated by: ', this.GeneratedBy],
            ],
          },
        },
      ];
      this.doc2.content.push(generatedUser);

      // Adding meter information on top of the logs table
      const installRec = [
        { text: '\nMeter Information', style: 'subheader' },
        {
          style: 'setraTable',
          layout: 'noBorders',
          table: {
            widths: [200, '*'],
            body: [
              ['Manufacturer', 'Setra Systems, Inc.'],
              ['Product', `SPM${this.$store.getDeviceModelNumberText()}EDN`],
              ['Serial Number', this.storeState.data.deviceInfo.serial],
              ['Meter Install Location', this.storeState.data.report.meter.location],
              ['Power Factor Sign Convention', this.powerFactorOptions[this.storeState.data.general.defaults.powerFactorSign].text],
              ['Demand Window', this.storeState.data.general.defaults.demandWindow],
            ],
          },
        },
      ];
      this.doc2.content.push(installRec);

      // Adding alarm setup table here
      const alarmList = [
        { text: '\nAlarm Setup', style: 'subheader' },
        {
          style: 'setraTable',
          table: {
            widths: [20, 110, '*', '*', '*', '*', 30, 30],
            headerRows: 1,
            body: [
              [{ text: '#', style: 'tableHeader' }, { text: 'Type', style: 'tableHeader' }, { text: 'Vin/Line/Load/CT', style: 'tableHeader' }, { text: 'Alarm Set Point', style: 'tableHeader' }, { text: 'Deadband', style: 'tableHeader' }, { text: 'Delay Seconds', style: 'tableHeader' }, { text: 'LED', style: 'tableHeader' }, { text: 'Relay', style: 'tableHeader' }],
            ],
          },
        },
      ];
      // loop over alarms
      for (let i = 0; i < this.storeState.data.alarms.length; i++) {
        const alarmObj = this.storeState.alarmTypes.find(({ value }) => value === this.storeState.data.alarms[i].type);
        const alarmItem = [
          this.storeState.data.alarms[i].id + 1,
          alarmObj.text,
          this.getvinLineLoadOrCtText(this.storeState.data.alarms[i]),
          (alarmObj.setPointApplicable ? `${this.storeState.data.alarms[i].setPoint} ${alarmObj.unit}` : '#NA'),
          (alarmObj.deadbandUnit !== '' ? `${this.storeState.data.alarms[i].deadband} ${alarmObj.deadbandUnit}` : '#NA'),
          (alarmObj.delayApplicable ? this.storeState.data.alarms[i].delay : '#NA'),
          (this.storeState.data.alarms[i].led ? 'Yes' : 'No'),
          (this.storeState.data.alarms[i].relay ? 'Yes' : 'No'),
        ];
        alarmList.find(({ style }) => style === 'setraTable').table.body.push(alarmItem);
      }
      this.doc2.content.push(alarmList);

      // Adding alarm logs table and contents here
      const alarmLogList = [
        { text: '\nAlarm Logs', style: 'subheader' },
        {
          style: 'setraTable',
          table: {
            widths: [65, 75, 150, 60, 60, 30, 30],
            headerRows: 1,
            body: [
              [{ text: 'Date', style: 'tableHeader' }, { text: 'Time', style: 'tableHeader' }, { text: 'Alarm Config', style: 'tableHeader' }, { text: 'Old State', style: 'tableHeader' }, { text: 'New State', style: 'tableHeader' }, { text: 'LED State', style: 'tableHeader' }, { text: 'Relay State', style: 'tableHeader' }],
            ],
          },
        },
      ];
      // loop over alarm log list
      for (let i = this.storeState.alarmLog.length - 1; i >= 0; i--) {
        const logItem = [
          this.realtimeTimestampToDate(this.storeState.alarmLog[i].timeEpoch),
          this.realtimeTimestampToTime(this.storeState.alarmLog[i].timeEpoch),
          this.$store.getAlarmTextForAlarmLogs(this.storeState.alarmLog[i].alarmConfig),
          this.$store.getStateTextForAlarmLogs(this.storeState.alarmLog[i].oldState),
          this.$store.getStateTextForAlarmLogs(this.storeState.alarmLog[i].alarmConfig.state),
          (this.storeState.alarmLog[i].led ? 'Yes' : 'No'),
          (this.storeState.alarmLog[i].relay ? 'Yes' : 'No'),
        ];
        alarmLogList.find(({ style }) => style === 'setraTable').table.body.push(logItem);
      }
      this.doc2.content.push(alarmLogList);

      this.$timer.start('downloadAlarmLogsRecord');
    },

    downloadAlarmLogsRecord() {
      const fileName = `SPM${this.$store.getDeviceModelNumberText()}EDN_${this.storeState.data.deviceInfo.serial}_Alarm_Log.pdf`;
      pdfMake.createPdf(this.doc2).download(fileName);
      this.updateDialog = false;
      this.updateText = '';
      this.GeneratedBy = '';
      this.$timer.stop('downloadAlarmLogsRecord');
    },

    realtimeTimestampToDate(value) {
      return new Date(value * 1000).toLocaleDateString('en-US');
    },
    realtimeTimestampToTime(value) {
      return new Date(value * 1000).toLocaleTimeString('en-US');
    },
    getCurrentTimeUtc() {
      let dateTime = new Date(this.storeState.now.getTime()); // Get date time (but in browser's timezone)
      dateTime = new Date(dateTime.getTime() + (dateTime.getTimezoneOffset() * 60000)); // get date time in UTC
      return dateTime;
    },
    getCurrentTime() {
      let dateTime = this.getCurrentTimeUtc();
      if (this.storeState.timezoneIndex !== -1 && this.storeState.timezones.length !== 0) { // Change date time to configured timezone
        dateTime = new Date(dateTime.getTime() + (this.storeState.timezones[this.storeState.timezoneIndex].offsetInt * 1000));
      }
      return dateTime;
    },
    close() {
      this.generatedByDialog = false;
      this.updateDialog = false;
      this.updateText = '';
      this.GeneratedBy = '';
    },
    confirm() {
      if (this.GeneratedBy === '') {
        return;
      }
      this.generatedByDialog = false;
      if (this.GeneratedBy !== '') {
        if (this.exportSource === 'CONFIG') {
          this.exportPdf();
        } else if (this.exportSource === 'ALARM_LOG') {
          this.exportAlarmLogs();
        }
      }
    },
    cancel() {
      this.generatedByDialog = false;
      this.GeneratedBy = '';
    },

    getVoltage(data, callback) {
      ajax.get('data/inputs')
        .then((res) => {
          for (let i = 0; i < data.inputs.length; i++) {
            if (data.inputs[i].service === 2 || data.inputs[i].service === 3) {
              this.actualVoltage[i] = Math.round(res.data.Input[i].lines[0].v_ll);
            } else {
              this.actualVoltage[i] = Math.round(res.data.Input[i].lines[0].v);
            }
            if (this.actualVoltage[i] === '0.000') {
              this.actualVoltage[i] = 'No voltage present';
            }
          }
          if (callback !== undefined) {
            callback();
          }
        })
        .catch((e) => {
          console.log(e); // eslint-disable-line no-console
          this.actualVoltage = ['No voltage present', 'No voltage present'];
          this.updateDialog = false;
          this.updateText = '';
        });
    },
    checkServiceWiring(input) {
      let res = 'No';
      let channelOffset = 0;

      // For second line channel number starts from 3,4,5
      if (input.id === 1) {
        channelOffset += 3;
      }
      for (let i = 0; i < input.lines.length; i++) {
        if (input.lines[i].active && (input.lines[i].channel !== (i + channelOffset))) {
          res = 'Yes';
        }
      }
      return res;
    },
    getvinLineLoadOrCtText(item) {
      if (this.storeState.alarmTypes.find(t => t.value === item.type).vinApplicable) {
        return `Vin ${item.vinLineLoadOrCt + 1}`;
      }
      if (this.storeState.alarmTypes.find(t => t.value === item.type).loadApplicable) {
        if (this.storeState.data.loads.length === 0) {
          return `Load ${item.vinLineLoadOrCt + 1}`;
        }
        return `Load ${item.vinLineLoadOrCt + 1} - ${this.storeState.data.loads[item.vinLineLoadOrCt].name}`;
      }
      if (this.storeState.alarmTypes.find(t => t.value === item.type).ctApplicable) {
        return `CT ${item.vinLineLoadOrCt + 1}`;
      }
      if (this.storeState.alarmTypes.find(t => t.value === item.type).lineApplicable) {
        if (item.vinLineLoadOrCt > 2) {
          return `Vin 2 - Line ${item.vinLineLoadOrCt - 2}`;
        }
        return `Vin 1 - Line ${item.vinLineLoadOrCt + 1}`;
      }
      return '#NA';
    },
    activeInputs() {
      const activeInputs = [];
      const inputs = this.storeState.data.inputs.filter(obj => (
        obj.active
      ));
      Object.values(inputs).forEach((input) => {
        Object.values(input.lines).forEach((line) => {
          if (line.active) {
            const lineNumber = line.channel - 3 * input.id;
            activeInputs.push({
              key: `L${line.channel}`,
              text: `Input ${input.id + 1} L${lineNumber + 1}-N`,
              id: line.channel,
              line: lineNumber,
            });
          }
        });
      });
      return activeInputs;
    },
    activeCts() {
      const activeCts = [];
      const cts = this.storeState.data.allCts.filter(obj => (
        obj.active
      ));
      Object.values(cts).forEach((ct) => {
        activeCts.push({
          key: `CT${ct.channel - 5}`,
          text: `CT ${ct.channel - 5}`,
          id: ct.channel,
        });
      });
      return activeCts;
    },
    exportConfig() {
      this.updateText = 'Downloading the file. Please wait.';
      this.updateDialog = true;
      const copy = JSON.parse(JSON.stringify(this.storeState.data));
      delete copy.pinEnabled;
      delete copy.report;
      const exportData = {};
      exportData.data = btoa(JSON.stringify(copy));
      exportData.version = '1.0';
      exportData.timestamp = new Date();
      exportData.hash = this.hashCode(exportData.data);
      const json = JSON.stringify(exportData);
      const blob = new Blob([json], { type: 'application/json' });
      const url = window.URL.createObjectURL(blob);
      this.$refs.downloadLink.href = url;
      this.$refs.downloadLink.click();
      this.snackbar = true;
      this.snackbarText = 'Exported configuration to file';
      this.$store.addEventLog('Exported configuration to file');
      this.$timer.start('exportConfigurationToFile');
    },

    exportConfigurationToFile() {
      this.updateDialog = false;
      this.updateText = '';
      this.$timer.stop('exportConfigurationToFile');
    },

    importConfig() {
      this.$refs.fileInput.click();
    },
    handleImport() {
      const fileInput = this.$refs.fileInput.files;
      const file = fileInput.item(0);
      const fr = new FileReader();

      fr.onload = (e) => {
        const json = JSON.parse(e.target.result);
        const hash = this.hashCode(json.data);
        json.data = JSON.parse(atob(json.data));
        if (hash !== json.hash) {
          this.snackbar = true;
          this.snackbarText = 'Failed to import configuration, invalid file';
          this.$store.addEventLog('Failed to import configuration');
          return;
        }
        delete json.data.deviceInfo;
        Object.keys(json.data).forEach((item) => {
          let importProperty = true;
          switch (item) {
            case 'general':
              if (!this.exportInfo) {
                importProperty = false;
              }
              break;
            case 'pinEnabled':
              importProperty = false;
              break;
            case 'loads':
              if (!this.exportLoad) {
                importProperty = false;
              }
              break;
            case 'allCts':
              if (!this.exportCt) {
                importProperty = false;
              }
              break;
            case 'inputs':
              if (!this.exportInputs) {
                importProperty = false;
              }
              break;
            case 'alarms':
              if (!this.exportAlarms) {
                importProperty = false;
              }
              break;
            case 'ethernet':
              if (!this.exportCommunication) {
                importProperty = false;
              }
              break;
            case 'communications':
              if (!this.exportCommunication) {
                importProperty = false;
              }
              break;
            case 'pulse':
              if (!this.exportPulse) {
                importProperty = false;
              }
              break;
            case 'report':
              importProperty = false; // We never import the report
              break;
            default:
              console.log( // eslint-disable-line no-console
                `Warning: Unknown property in export data named "${item}", ignoring...`,
              );
              importProperty = false;
              break;
          }
          if (importProperty) {
            Vue.set(this.storeState.data, item, json.data[item]);
            if (item === 'inputs') {
              this.storeState.voltageDirty = true;
              Vue.set(this.storeState, 'mappingSaved', false);
            } else if (item === 'loads') {
              this.storeState.loadDirty = true;
              Vue.set(this.storeState, 'mappingSaved', false);
            } else if (item === 'allCts') {
              this.storeState.ctDirty = true;
              Vue.set(this.storeState, 'mappingSaved', false);
            } else {
              this.storeState[`${item}Dirty`] = true;
            }
          }
        });

        // Set default values for configuration items that did not exist on old versions of exported config
        if (
          this.storeState.data.general.defaults.billingCycleDay === undefined
        ) {
          this.storeState.data.general.defaults.billingCycleDay = 1;
        }
        if (
          this.storeState.data.general.defaults.billingCycleTime === undefined
        ) {
          this.storeState.data.general.defaults.billingCycleTime = 0;
        }
        if (this.storeState.data.inputs[0].voltageScaler === undefined) {
          this.storeState.data.inputs[0].voltageScaler = 1;
        }
        if (this.storeState.data.inputs[1].voltageScaler === undefined) {
          this.storeState.data.inputs[1].voltageScaler = 1;
        }
        if (this.storeState.data.pulse[0].scaler === undefined) {
          this.storeState.data.pulse[0].scaler = 1;
        }
        if (this.storeState.data.pulse[1].scaler === undefined) {
          this.storeState.data.pulse[1].scaler = 1;
        }
        if (this.storeState.data.pulse[2].scaler === undefined) {
          this.storeState.data.pulse[2].scaler = 1;
        }

        this.snackbar = true;
        this.snackbarText = 'Sucessfully imported configuration from file';
        this.$store.addEventLog('Imported configuration from file');
      };
      fr.readAsText(file);
    },

    getBase64Image(img) {
      const canvas = document.createElement('canvas');
      canvas.width = img.width;
      canvas.height = img.height;
      const ctx = canvas.getContext('2d');
      ctx.drawImage(img, 0, 0);
      const dataURL = canvas.toDataURL('image/png');
      return dataURL.replace(/^data:image\/(png|jpg);base64,/, '');
    },

    OEMlabel() {
      if (this.storeState.style === 'fluke') {
        return this.getBase64Image(this.$refs.flukeLabel);
      }
      if (this.storeState.style === 'siemens') {
        return this.getBase64Image(this.$refs.siemensLabel);
      }
      return this.getBase64Image(this.$refs.setraLabel);
    },

    getOEMLabelWidth() {
      if (this.storeState.style === 'fluke') {
        return 120;
      }
      if (this.storeState.style === 'siemens') {
        return 169;
      }
      return 80;
    },

    getOEMLabelHeight() {
      if (this.storeState.style === 'fluke') {
        return 36;
      }
      if (this.storeState.style === 'siemens') {
        return 27;
      }
      return 40;
    },
  },

  timers: {
    downloadPowerMeterInstallationRecord: { time: 1000, repeat: false, autostart: false },
    downloadAlarmLogsRecord: { time: 1000, repeat: false, autostart: false },
    exportConfigurationToFile: { time: 1000, repeat: false, autostart: false },
  },
};
</script>
